// extracted by mini-css-extract-plugin
module.exports = {"isActive":"DesktopNavLink_isActive__Qb_oR","isInactive":"DesktopNavLink_isInactive__WipPR"};